import { getServicesPropsGroup } from "../services";

const useGrupos = () => {
    const fetchGrupos = async () => {
        try {
            const response = await getServicesPropsGroup();
            let misDatos = formData(response);  
            // localStorage.setItem("states", JSON.stringify(misDatos));
            return misDatos;
        } catch (error) {
            console.error("Error fetching grupos:", error);
        }
    }

    const formData = (datos)=> {
        return datos.map((item) => ({
            id: item.id,
            nombre: item.nombre,
        }));
    }

    return {
        fetchGrupos
    };
}

export default useGrupos;